import React from "react";

import { AppContext } from '../util';
class Tooltip extends React.Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);
        
        this.state = {
            x: window.innerWidth/2,
            y: window.innerHeight/2,
            year: '',
            title: '',
            actorInRole: ''
        }
    }

    componentWillReceiveProps(props) {
        if(!props.item) return;
        const {year, title, actorInRole} = props.item.props;
        this.setState({year, title, actorInRole});
    }

    update() {
        const x = this.state.x + (this.context.mousePosition.x - this.state.x)*0.1;
        const y = this.state.y + (this.context.mousePosition.y - this.state.y)*0.1;

        this.setState({x, y});
    }

    render() {

        const classes = this.props.item ? 'tooltip' : 'tooltip tooltip--hidden';
        const style = { transform: `translateX(${this.state.x}px) translateY(${this.state.y}px)` };

        return (
            <section className={classes} style={style}>
                <div className="tooltip__year">{this.state.year}</div>
                <div className="tooltip__artist">{this.state.actorInRole}</div>
                <div className="tooltip__title">{this.state.title}</div>
            </section>
        )
    }
}

export default Tooltip;